import { batchGenFn } from '@/api/request'

const genPostFn = batchGenFn()

/**
 * 应用中心模块
 */
export const getAppList = genPostFn('/rpa/app/system/findList')
export const getAppDetail = genPostFn('/rpa/app/findDetail')
